import buildEvents from '../buildEvents';

import resetRequest from './resetRequest';

const eventWrapper = methods => buildEvents([resetRequest], methods);

export default eventWrapper;
